import * as React from "react";
import { useState } from "react";
import capitalize from "lodash/capitalize";
import { useQueryClient } from "@tanstack/react-query";
import useProductName from "brand-customization/useProductName";
import useStreamDataLakeStatusMutation from "data-lake/hooks/useStreamDataLakeStatusMutation";
import { ConfirmDialog, OverlayTrigger, Link } from "components/common";
import Popover from "components/common/Popover";
import { useDataLakeBackendConfig } from "data-lake/data-lake-backend-config/hooks/useDataLakeBackendConfig";
import DestinationSwitch from "components/streams/StreamDetails/routing-destination/DestinationSwitch";
import usePermissions from "hooks/usePermissions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import DataLakeRoutes from "data-lake/Routes";
import AppConfig from "util/AppConfig";
const StreamDataLakeEnableButton = ({ streamId, config }) => {
  const [showModal, setShowModal] = useState(false);
  const { onToggleStreamDataLakeConfigStatus } = useStreamDataLakeStatusMutation();
  const { data, isSuccess } = useDataLakeBackendConfig();
  const isDataLakeEnabled = (config == null ? void 0 : config.enabled) || false;
  const action = isDataLakeEnabled ? "disable" : "enable";
  const title = isDataLakeEnabled ? "Enabled" : "Disabled";
  const activeBackendExists = isSuccess && data.active_backend;
  const queryClient = useQueryClient();
  const { isPermitted } = usePermissions();
  const sendTelemetry = useSendTelemetry();
  const productName = useProductName();
  const onModalClose = () => {
    setShowModal(false);
  };
  const onButtonClick = () => {
    setShowModal(true);
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.ENABLE_DATALAKE_CLICKED, {
      app_pathname: "data-lake"
    });
  };
  const onConfirm = () => {
    onToggleStreamDataLakeConfigStatus({ streamIds: [streamId], enabled: !isDataLakeEnabled }).then(() => {
      setShowModal(false);
      queryClient.invalidateQueries({
        queryKey: ["data-lake", streamId]
      });
      queryClient.invalidateQueries({
        queryKey: ["data-lake", "stream", streamId]
      });
    });
  };
  const popover = /* @__PURE__ */ React.createElement(Popover, null, "No active Data Lake backend configured.", " ", AppConfig.isCloud() ? `Contact ${productName} support to set one up.` : /* @__PURE__ */ React.createElement(React.Fragment, null, "Go to ", /* @__PURE__ */ React.createElement(Link, { to: DataLakeRoutes.BACKEND }, "Data Lake/Backend"), " and set one up to use Data Lake."));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showModal && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showModal,
      onConfirm,
      onCancel: onModalClose,
      title: `${capitalize(action)} Data Lake.`
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, "You are about to ", `${action}`, " ", /* @__PURE__ */ React.createElement("strong", null, "Data Lake"), " on this stream.", /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to continue?"))
  ), activeBackendExists ? /* @__PURE__ */ React.createElement(
    DestinationSwitch,
    {
      "aria-label": "Toggle data lake",
      name: "toggle-data-lake",
      checked: isDataLakeEnabled,
      onChange: onButtonClick,
      disabled: !isPermitted(["data_lake_config:update", `streams:edit:${streamId}`]),
      label: title
    }
  ) : /* @__PURE__ */ React.createElement(OverlayTrigger, { placement: "top", trigger: "click", rootClose: true, overlay: popover }, /* @__PURE__ */ React.createElement(
    DestinationSwitch,
    {
      "aria-label": "Toggle data lake",
      name: "toggle-data-lake",
      disabled: true,
      onChange: () => {
      },
      checked: false,
      label: title
    }
  )));
};
export default StreamDataLakeEnableButton;
